import axios from 'axios';
import { toast } from 'sonner';

import { SET_MESSAGE_AUTOMATIONS } from './types';

export const setMessageAutomations =
	({ messageAutomations }) =>
	async (dispatch) => {
		dispatch({
			type: SET_MESSAGE_AUTOMATIONS,
			payload: messageAutomations,
		});
	};

export const getMessageAutomations = () => async (dispatch) => {
	try {
		const res = await axios.get('/api/automation/message-automations', {
			_suppressErrorToast: true,
		});

		const { data } = res;

		if (data.error) {
			toast.error('Failed to load automations', {
				description: data.message || 'Please try again.',
			});
			return { error: true };
		}

		if (data.messageAutomations) {
			dispatch({
				type: SET_MESSAGE_AUTOMATIONS,
				payload: data.messageAutomations,
			});

			return { error: false };
		}

		toast.error('Failed to load automations', {
			description: 'Unexpected server response.',
		});
		return { error: true };
	} catch (err) {
		toast.error('Failed to load automations', {
			description:
				(err &&
					err.response &&
					(err.response.data?.message || err.response.data?.error)) ||
				(err && err.message) ||
				'Please try again.',
		});
		return { error: true };
	}
};
